import { render } from "./DTextArea.vue?vue&type=template&id=5361980c&lang=pug"
import script from "./DTextArea.vue?vue&type=script&lang=js"
export * from "./DTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__